module.exports = __webpack_public_path__ + "media/images/zj11-c2-33700f36bfb5dbfdf0b88bca7243a4d4.png";